import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "information_press",
  "use": "information_press-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"information_press\"><path d=\"M9 1.714C4.983 1.714 1.714 4.982 1.714 9S4.984 16.286 9 16.286c4.017 0 7.286-3.268 7.286-7.286S13.017 1.714 9 1.714M9 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m2 6.503c0 .688-.558 1.247-1.247 1.247H7v-.211c0-.698.557-1.26 1.25-1.281V9.5H7A1.5 1.5 0 0 1 8.5 8h1.25v3.25H11z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol